<template>
  <div class="youku-play-page">
    <div class="video-container">
      <div id="youkuplayer" class="player"></div>
    </div>
    <div class="content-wrapper">
      <div class="video-info">
        <h1>{{ videoInfo.title }}</h1>
        <p class="description">{{ videoInfo.brief }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  name: 'YouKuPlayPage',
  data() {
    return {
      videoInfo: {}
    }
  },
  mounted() {
    this.getVideoInfo()
  },
  methods: {
    getVideoInfo() {
      const id = this.$route.query.id
      if (!id) return
      this.$axios({
        url: '/realNet/video/getVideoInfos',
        method: 'get',
        params: { id },
        headers: { token: getToken() }
      }).then(res => {
        if (res.data.code === 200) {
          const result = res.data.result
          this.videoInfo = result.videoInfo || result
          if (this.videoInfo.videoId) {
            this.playVideo(this.videoInfo.videoId)
          }
        }
      })
    },
    playVideo(videoId) {
      localStorage.setItem('video_id', JSON.stringify(videoId))
      if (window.YKU) {
        new window.YKU.Player('youkuplayer', {
          styleid: '0',
          client_id: 'f87946c9efe4a1db',
          vid: videoId,
          newPlayer: true,
          autoplay: true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.youku-play-page {
  width: 100%;
  padding-top: $header-height;
}

.video-container {
  width: 100%;
  background: #000;

  .player {
    width: $content-width;
    height: 600px;
    margin: 0 auto;
  }
}

.content-wrapper {
  width: $content-width;
  margin: 0 auto;
  padding: 30px 0;
}

.video-info {
  h1 { font-size: 24px; margin-bottom: 10px; }
  .description {
    font-size: 14px;
    color: #666;
    margin-top: 15px;
    line-height: 1.6;
  }
}
</style>
